import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '@org/ui';
import { IdentityReviewList } from '../app/components/identity/identity-review-list';

// Self sign-ups whose selfie / ID photo the AI could not confirm: a human
// approves or declines here. Same permission as the sidebar item.
export const Route = createFileRoute('/identity-reviews')({
  component: IdentityReviewsRoute,
});

function IdentityReviewsRoute() {
  return (
    <ProtectedRoute requiredPermissions={['admin:all', 'users:write']}>
      <div className="space-y-6 pt-4">
        <IdentityReviewList />
      </div>
    </ProtectedRoute>
  );
}
